export default {
  setFileExtension(url) {
    if (!url) return;
    const _url = url.substring(1 + url.lastIndexOf('/'));
    return _url
      .split('?')[0]
      .split('#')[0]
      .substring(_url.lastIndexOf('.'))
      .toLowerCase();
  },
};